import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ProgressButton from '../_utils/progress-button';
import { builderDispatch, WebUI } from '../_utils/ui';
import { observableEvent } from '../_utils/observable-event';
import { checkoutBlockers } from './checkout-blockers';
import AnalyticsHandler from '../_libs/analytics/checkout-google-analytics';

const CheckOutButton = createReactClass({
  componentDidMount() {
    this.builderDispatchToken = builderDispatch.register(payload => {
      switch (payload.type) {
        case WebUI.LOGIN:
          if (this.checkoutLoginRequested) {
            payload.previous_basket_contents || this.navigateTo();
          }
          break;
      }
    });
  },
  componentWillUnmount() {
    builderDispatch.unregister(this.builderDispatchToken);
  },

  handleCheckoutLogin() {
    const showLoginEvent = new Event('showLogin');
    window.dispatchEvent(showLoginEvent);
    this.checkoutLoginRequested = true;
  },

  sendGoogleAnalyticsEvent() {
    const payload = {
      type: WebUI.Analytics.BEGIN_CHECKOUT_EVENT
    }
    AnalyticsHandler.handleAnalyticsEvent(payload);
  },

  render() {
    const classes = [
      'checkout-button',
      'btn',
      'btn-primary',
      'btn-lg',
      'btn-block',
    ];
    const {
      checkoutBlocker,
      text,
      crossSellItemCheckOutClick,
      checkoutDisabled,
    } = this.props;

    const { loggedIn, checkout } = this.context;
    const btnText = text || 'Check Out';

    if (checkoutBlocker === checkoutBlockers.crossSellItem) {
      return (
        <button
          id="cart-btn-cxo-block-xsell"
          className={classNames(classes)}
          onClick={() => {
            this.sendGoogleAnalyticsEvent();
            crossSellItemCheckOutClick();
          }}>
          {btnText}
        </button>
      );
    }

    if (loggedIn || checkout.withoutLogin) {
      if (checkoutDisabled) {
        return (
          <button
            id="cart-btn-cxo-block"
            className={classNames(classes)}
            disabled={checkoutDisabled}>
            {btnText}
          </button>
        );
      }

      return (
        <ProgressButton
          id="cart-btn-cxo"
          data-test-id="checkout-button"
          className={classNames(classes)}
          onClick={this.sendGoogleAnalyticsEvent}
          href={checkout.url}
          timeoutMs={60000}
          onTimeout={this.handleProgressButtonTimeout}>
          {btnText}
        </ProgressButton>
      );
    }

    return (
      <button
        id="cart-btn-cxo-login"
        data-test-id="checkout-button"
        className={classNames(classes)}
        onClick={this.handleCheckoutLogin}
        disabled={checkoutDisabled}>
        {btnText}
      </button>
    );
  },
  navigateTo() {
    const url = this.context.checkout.url;
    if (url !== window.location.href) {
      // Don't send analytics if the redirection is back to the cart page
      // The checkout button will handle this onClick
      this.sendGoogleAnalyticsEvent();
    }

    let f = document.createElement('FORM'),
      indexQM,
      params,
      keyValuePair,
      input,
      i;

    f.action = url;
    indexQM = url.indexOf('?');

    if (indexQM > -1) {
      // the URL has parameters => convert them to hidden form inputs
      params = url.substring(indexQM + 1).split('&');
      for (i = 0; i < params.length; i++) {
        keyValuePair = params[i].split('=');
        input = document.createElement('INPUT');
        input.type = 'hidden';
        input.name = keyValuePair[0];
        input.value = keyValuePair[1];
        f.appendChild(input);
      }
    }

    document.body.appendChild(f);
    f.submit();
  },
  handleProgressButtonTimeout(progressButton) {
    observableEvent.record('checkout-button-timeout');
    progressButton.reset();
    alert(
      'There was a problem transferring you to checkout. The failure has been logged. Please try again.'
    );
  },
});

CheckOutButton.contextTypes = {
  loggedIn: PropTypes.bool,
  checkout: PropTypes.shape({
    withoutLogin: PropTypes.bool,
    url: PropTypes.string,
  }),
};

export default CheckOutButton;
